import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30f1f6a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-sm-12" }
const _hoisted_2 = { class: "card mt-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-header" }, "Personne qui atteste", -1 /* HOISTED */))
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "attestation.personneAttesteMemeRepondant"
}, " La personne qui atteste est la même que le répondant ", -1 /* HOISTED */))
const _hoisted_7 = {
  key: 0,
  class: "col-lg-4 col-md-6 col-sm-12"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "attestation.personne.nomComplet" }, "Nom complet", -1 /* HOISTED */))
const _hoisted_9 = ["readonly"]
const _hoisted_10 = {
  key: 1,
  class: "col-lg-4 col-md-6 col-sm-12"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "attestation.personne.fonction" }, "Fonction", -1 /* HOISTED */))
const _hoisted_12 = ["readonly"]
const _hoisted_13 = {
  key: 2,
  class: "col-lg-4 col-md-6 col-sm-12"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "attestation.personne.courriel" }, "Courriel", -1 /* HOISTED */))
const _hoisted_15 = ["readonly"]
const _hoisted_16 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_17 = {
  key: 3,
  class: "col-lg-4 col-md-6 col-sm-12"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "attestation.personne.telephone" }, "Téléphone", -1 /* HOISTED */))
const _hoisted_19 = ["readonly"]
const _hoisted_20 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_21 = {
  key: 4,
  class: "col-lg-4 col-md-6 col-sm-12"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "attestation.personne.commentaire" }, "Commentaire", -1 /* HOISTED */))
const _hoisted_23 = ["readonly"]
const _hoisted_24 = { class: "card mt-3" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-header" }, "Disponibilité du fonds général, d'autres fonds et de réserves financières", -1 /* HOISTED */))
const _hoisted_26 = { class: "card-body atteste-flex" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "attestation.attestationDisponibiliteFonds"
}, " J'atteste ", -1 /* HOISTED */))
const _hoisted_29 = { class: "card mt-3" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-header" }, "Dépenses engagées", -1 /* HOISTED */))
const _hoisted_31 = { class: "card-body atteste-flex" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "En vertu des articles 544.1 de la Loi sur les cités et villes ou 1063.1 du Code municipal du Québec, le renflouement du fonds général pour les dépenses engagées avant l'entrée en vigeur du règlement ne doit pas excéder 5 % des dépenses prévues au règlement. Le taux est de 10 % si le règlement ne requiert pas l'approbation des personnes habiles à voter.", -1 /* HOISTED */))
const _hoisted_33 = { class: "col-sm-12 mt-2" }
const _hoisted_34 = {
  for: "attestation.montantDepensesEngagees",
  class: "me-2 col-form-label"
}
const _hoisted_35 = { class: "form-group col-sm mnt" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "attestation.attestationDepensesEngagees"
}, " J'atteste ", -1 /* HOISTED */))
const _hoisted_38 = { class: "card mt-3" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-header" }, "Attestation des renseignements fournis", -1 /* HOISTED */))
const _hoisted_40 = { class: "card-body atteste-flex" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "attestation.attestationRenseignementsFournis"
}, " J'atteste ", -1 /* HOISTED */))
const _hoisted_43 = { class: "text-end" }
const _hoisted_44 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputMontant = _resolveComponent("InputMontant")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    title: "Attestation",
    "forced-opened": _ctx.forcedOpened,
    opened: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input",
                disabled: _ctx.reglement.statut === _ctx.Statut.TransmisMinistere,
                id: "attestation.personneAttesteMemeRepondant",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reglement.attestation.personneAttesteMemeRepondant) = $event)),
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onPersonneMemeQueRepondantChange && _ctx.onPersonneMemeQueRepondantChange(...args)))
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_5), [
                [_vModelCheckbox, _ctx.reglement.attestation.personneAttesteMemeRepondant]
              ]),
              _hoisted_6
            ]),
            (!_ctx.reglement.attestation.personneAttesteMemeRepondant)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "attestation.personne.nomComplet",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reglement.attestation.personne.nomComplet) = $event)),
                    readonly: _ctx.reglement.statut === _ctx.Statut.TransmisMinistere
                  }, null, 8 /* PROPS */, _hoisted_9), [
                    [_vModelText, _ctx.reglement.attestation.personne.nomComplet]
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (!_ctx.reglement.attestation.personneAttesteMemeRepondant)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "attestation.personne.fonction",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.reglement.attestation.personne.fonction) = $event)),
                    readonly: _ctx.reglement.statut === _ctx.Statut.TransmisMinistere
                  }, null, 8 /* PROPS */, _hoisted_12), [
                    [_vModelText, _ctx.reglement.attestation.personne.fonction]
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (!_ctx.reglement.attestation.personneAttesteMemeRepondant)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "attestation.personne.courriel",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.reglement.attestation.personne.courriel) = $event)),
                    readonly: _ctx.reglement.statut === _ctx.Statut.TransmisMinistere,
                    onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onCourrielChange && _ctx.onCourrielChange(...args)))
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_15), [
                    [_vModelText, _ctx.reglement.attestation.personne.courriel]
                  ]),
                  (!_ctx.champsValides.courriel)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.messagesValidation.courriel), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            (!_ctx.reglement.attestation.personneAttesteMemeRepondant)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "attestation.personne.telephone",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.reglement.attestation.personne.telephone) = $event)),
                    placeholder: "999-999-9999#999999",
                    readonly: _ctx.reglement.statut === _ctx.Statut.TransmisMinistere,
                    onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onTelephoneChange && _ctx.onTelephoneChange(...args)))
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_19), [
                    [_vModelText, _ctx.reglement.attestation.personne.telephone]
                  ]),
                  (!_ctx.champsValides.telephone)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.messagesValidation.telephone), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            (!_ctx.reglement.attestation.personneAttesteMemeRepondant)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _hoisted_22,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "attestation.personne.commentaire",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.reglement.attestation.personne.commentaire) = $event)),
                    readonly: _ctx.reglement.statut === _ctx.Statut.TransmisMinistere
                  }, null, 8 /* PROPS */, _hoisted_23), [
                    [_vModelText, _ctx.reglement.attestation.personne.commentaire]
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("p", null, "L'organisme municipal dispose actuellement des crédits pour un montant de " + _toDisplayString(_ctx.reglement.financieres.credits.total) + " $ provenant du fonds général, de tout autre fonds et de réserves financières à affecter au règlement.", 1 /* TEXT */),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input",
                disabled: _ctx.reglement.statut === _ctx.Statut.TransmisMinistere,
                id: "attestation.attestationDisponibiliteFonds",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.reglement.attestation.attestationDisponibiliteFonds) = $event))
              }, null, 8 /* PROPS */, _hoisted_27), [
                [_vModelCheckbox, _ctx.reglement.attestation.attestationDisponibiliteFonds]
              ]),
              _hoisted_28
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", null, [
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("label", _hoisted_34, " En date du " + _toDisplayString(_ctx.Helpers.formatDateTexte(new Date())) + ", la dépense engagée au règlement " + _toDisplayString(_ctx.reglement.infosLegales.numero) + " est de ", 1 /* TEXT */),
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.attestation,
                    champ: "montantDepensesEngagees",
                    id: "attestation.montantDepensesEngagees",
                    readonly: _ctx.reglement.statut === _ctx.Statut.TransmisMinistere
                  }, null, 8 /* PROPS */, ["parent", "readonly"])
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input",
                disabled: _ctx.reglement.statut === _ctx.Statut.TransmisMinistere || !_ctx.reglement.attestation.montantDepensesEngagees || _ctx.reglement.attestation.montantDepensesEngagees < 0,
                id: "attestation.attestationDepensesEngagees",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.reglement.attestation.attestationDepensesEngagees) = $event))
              }, null, 8 /* PROPS */, _hoisted_36), [
                [_vModelCheckbox, _ctx.reglement.attestation.attestationDepensesEngagees]
              ]),
              _hoisted_37
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("p", null, "Je, " + _toDisplayString(_ctx.reglement.attestation.personneAttesteMemeRepondant ? `${_ctx.reglement.entite.repondant.prenom}
                                            ${_ctx.reglement.entite.repondant.nom}` : _ctx.reglement.attestation.personne.nomComplet) + ", " + _toDisplayString(_ctx.reglement.attestation.personneAttesteMemeRepondant ? _ctx.reglement.entite.repondant.fonction :
                            _ctx.reglement.attestation.personne.fonction) + ", certifie que les renseignements fournis dans cette demande sont exacts.", 1 /* TEXT */),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input",
                disabled: _ctx.reglement.statut === _ctx.Statut.TransmisMinistere,
                id: "attestation.attestationRenseignementsFournis",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.reglement.attestation.attestationRenseignementsFournis) = $event))
              }, null, 8 /* PROPS */, _hoisted_41), [
                [_vModelCheckbox, _ctx.reglement.attestation.attestationRenseignementsFournis]
              ]),
              _hoisted_42
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          (_ctx.reglement.statut !== _ctx.Statut.TransmisMinistere)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-primary",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.corrigerInfos && _ctx.corrigerInfos(...args)))
              }, "Corriger les informations"))
            : _createCommentVNode("v-if", true),
          _createElementVNode("button", {
            disabled: !_ctx.validateTelechargement(_ctx.reglement),
            class: "btn btn-primary",
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.envoyerMinistere && _ctx.envoyerMinistere(...args)))
          }, "Télécharger pour envoyer au Ministère", 8 /* PROPS */, _hoisted_44)
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["forced-opened"]))
}